<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7jznNT/tc-custom/9781617756863.jpg?1726617321244" alt="This image is the cover for the book Amsterdam Noir, Akashic Noir"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amsterdam Noir, Akashic Noir
      </h1>
      <p class="bookDescription body article font2">
        <b>This anthology of new noir fiction set in the Dutch capital “features superior writing from authors largely unknown to an American audience” (<i>Publishers Weekly</i>).</b><br/>  <br/> From its numerous coffee shops where drugs are openly available, to its world-famous Red Light District where prostitutes display themselves in shop windows, Amsterdam is a city where almost anything goes in broad daylight. And yet, this serene city of canals has its dark side as well. In fifteen tales of greed, jealousy and revenge, some of the finest Dutch crime writers—including literary award-winners and international bestsellers—explore the seamy shadows of this historic city.<br/>  <br/><i>Amsterdam Noir</i> features brand-new stories by: Michael Berg, Anneloes Timmerije, Murat Isik, René Appel &amp; Josh Pachter, Simon de Waal, Hanna Bervoets, Karin Amatmoekrim, Christine Otten, Mensje van Keulen, Max van Olden, Theo Capel, Loes den Hollander, Herman Koch, Abdelkader Benali, and Walter van den Berg, whose story "Get Rich Quick" won the inaugural Literatuurprijs Nieuw-West award.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        René Appel, Josh Pacter, Herman Koch, Hanna Bervoets
      </h2>
      
      <p class="authorDescription body article">René Appel published his first thriller, Handicap, in 1987, and has written twenty more, two of which have received the Golden Noose, the annual award for the best Dutch-language crime novel. English translations of his stories have appeared in Ellery Queen’s Mystery Magazine, Alfred Hitchcock’s Mystery Magazine, and several anthologies.Josh Pachter is an American writer, editor, and translator. His short crime stories have been featured in Ellery Queen’s Mystery Magazine and Alfred Hitchcock’s Mystery Magazine, among other places, and his translations of crime fiction by Dutch and Belgian authors appear regularly in EQMM. He lives in Northern Virginia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Akashic Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7aed9b30